import React from 'react';
import moment from 'moment';
import { Table } from '@cimpress/react-components';
import { ManifestLogEvent } from '../../models/manifest';

interface Props {
  loading: boolean;
  data: ManifestLogEvent[];
}

function formatData(data: ManifestLogEvent[]) {
  return data.map((e: ManifestLogEvent) => ({
    ...e,
    timestamp: moment(e.timestamp).format('kk:mm:ss.SS YYYY-MM-DD'),
  }));
}

// tslint:disable-next-line:function-name
export default function ManifestEventLogTable({ data, loading }: Props) {
  const narrowColumn = 180;
  const columns = [{
    Header: 'Level',
    accessor: 'level',
    maxWidth: 120,
  }, {
    Header: 'Timestamp',
    accessor: 'timestamp',
    maxWidth: narrowColumn,
  }, {
    Header: 'Manifest Job Id',
    accessor: 'manifestJobId',
    maxWidth: narrowColumn,
  }, {
    Header: 'Message',
    accessor: 'message',
  }];

  return (<Table columns={columns} data={formatData(data)} loading={loading} />);
}
